import { useEffect, useRef, useState } from "react";

// material-ui
import { Box, ClickAwayListener, Fade, IconButton, Paper, Popper, Stack, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

// project imports
import LocalizationSection from "../LocalizationSection";

// assets
import { IconDotsVertical } from "@tabler/icons";

// ==============================|| MOBILE HEADER ||============================== //

const MobileSection = () => {
  const theme = useTheme();
  const matchMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [open, setOpen] = useState(false);
  /**
   * anchorRef is used on different componets and specifying one type leads to other components throwing an error
   * */
  const anchorRef = useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={handleToggle}
        sx={{
          background: theme.palette.mode === "dark" ? theme.palette.grey[800] : theme.palette.grey[100],
          border: `1px solid ${theme.palette.divider}`,

          "&:hover": {
            background: theme.palette.mode === "dark" ? theme.palette.grey[700] : theme.palette.grey[200],
            transform: "scale(1.05)",
          },
          transition: "all 0.2s ease-in-out",
        }}>
        <IconDotsVertical stroke={1.5} size="1.3rem" color={theme.palette.text.primary} />
      </IconButton>

      <Popper
        placement="bottom-end"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, 8],
              },
            },
          ],
        }}>
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={200}>
            <Paper
              sx={{
                border: `1px solid ${theme.palette.divider}`,
                boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
                minWidth: 200,
                backgroundColor: theme.palette.background.paper,
              }}>
              <ClickAwayListener onClickAway={handleClose}>
                <Box sx={{ p: 2 }}>
                  <Stack spacing={2}>
                    <LocalizationSection />
                  </Stack>
                </Box>
              </ClickAwayListener>
            </Paper>
          </Fade>
        )}
      </Popper>
    </>
  );
};

export default MobileSection;
